import { render, staticRenderFns } from "./CompanySettingsForm.vue?vue&type=template&id=4b18ca9a&scoped=true&"
import script from "./CompanySettingsForm.vue?vue&type=script&lang=ts&"
export * from "./CompanySettingsForm.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySettingsForm.vue?vue&type=style&index=0&id=4b18ca9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18ca9a",
  null
  
)

export default component.exports